import Article from '@/models/Article';
import articleService from '@/services/article.service.js';
import Formatter from '@/functions/Formatter';
import Permissions from '@/UserPermissions/v-can_Directive';

const state = {
    articles: []
}

const mutations = {
    SET_ARTICLES(state, articles){
        state.articles = articles;
    },
    ADD_ARTICLE(state, article){
        state.articles.push(article);
    },
    EDIT_ARTICLE(state, article){
        let articleIndex = state.articles.findIndex(a => a.id == article.id);
        state.articles[articleIndex] = article;
    },
    DELETE_ARTICLE(state, article){
        state.articles = state.articles.filter(a => a.id != article.id);
    }
}

const actions = {
    setArticles({ commit }, articles) {
        articles = Formatter.formatArticles(articles);
        commit('SET_ARTICLES', articles);
    },
    // payload, ownerId and isAboutMe fields
    async createArticle({dispatch, commit, state}, payload) {
        let article = new Article();
        if(payload.isAboutMe){
            article.is_about_me = payload.isAboutMe;
            article.title = "Min presentation";
            article.description = "Här kan du skapa en presentation om dig själv.";
            article.published = true;
        }
        article.owner = payload.ownerId;
        article.is_news_article = payload.isNewsArticle ?? false;

        try {
            let response = await articleService.add(article);
            article = Formatter.formatArticle(response.data);
            commit('ADD_ARTICLE', article);           
            dispatch('updateArticles', state.articles);

            return article;
        } 
        catch (error) {
            console.log(error.response ? error.response.status : error);
        }
    },
    async updateArticle({commit}, article){
        if(!article) return;

        try {
            let response = await articleService.update(article);
            article = Formatter.formatArticle(response.data);
            commit('EDIT_ARTICLE', article);
        } 
        catch (error) {
            console.log(error.response ? error.response.status : error);
        }
    },
    async deleteArticle({commit, dispatch, state} , article){
        if(!article) return;

        try {
            await articleService.delete(article);
            commit('DELETE_ARTICLE', article);
            dispatch('updateArticles', state.articles);

        } catch (error) {
            console.log(error.response ? error.response.status : error);
        }
    },
    clearArticles({ commit }){
        commit("SET_ARTICLES", []);
    }
}

const getters = {
    getAllArticles: (state) =>{
        return state.articles;
    },
    getArticlesByCategory: (state) => (categoryId) => {
        let articlesByCategory = [];
        let articleCount = state.articles.length;

        for (let i = 0; i < articleCount; i++) {         
            let article = state.articles[i];
            const isArticleOwner = JSON.parse(localStorage.getItem('user')).user.id;
            let articleSecurityGroups = 0;
            if(article.security_groups.length > 0)
                articleSecurityGroups = article.security_groups.reduce((x, y) => x + y);
            
            if(!Array.isArray(article.categories)){
                const temp = article.categories;
                article.categories = [];
                article.categories.push(temp);
            }

            if(article.categories?.includes(categoryId) && Permissions.userCanAny(articleSecurityGroups, isArticleOwner)){
                articlesByCategory.push(article); 
            }           
        }
        return articlesByCategory; 
    },
    getArticleBySectionId: (state) => (sectionId) => {
        return state.articles.find(a => a.sections.find(s => s.id === sectionId));
    },
    getArticleById: (state) => (articleId) => { 
        return state.articles.find(a => a.id == articleId);
    },
    getArticleAboutMe: (state) => {
        return state.articles.find(a => a.is_about_me);
    }
}

export default {
    state,
    mutations,
    actions,
    getters
}